import React from 'react';
import clsx from 'clsx';
import { Link } from 'react-router-dom';

const NameCellContent = ({
  children,
  className,
  disabled,
  href,
  link,
  name,
  onClick,
}) => {
  const myHref = disabled ? undefined : href;
  const myLink = disabled ? undefined : link;
  const handleClick = onClick ? (e) => {
    e.preventDefault(); onClick(e);
  } : undefined;
  const myClassName = clsx('aridhia-name.cell-content', className);

  return (
    <>
      {myHref && (
        <a
          className={myClassName}
          href={myHref}
          onClick={handleClick}
          rel="noopener noreferrer"
          target="_blank"
        >
          {children}
        </a>
      )}
      {myLink && (<Link className={myClassName} to={myLink} title={name}>{children}</Link>)}
      {!myHref && !myLink && (<span className={myClassName} title={name}>{children}</span>)}
    </>
  );
};

export default NameCellContent;
